module.exports = __webpack_public_path__ + "media/images/official/special_sightseen_18-2709a91df242cdf2c99001a388040792.jpg";